module.exports = __webpack_public_path__ + "2020celebration/img/accident-r-1.d99d58a7.png";